"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabourRateType = void 0;
var LabourRateType;
(function (LabourRateType) {
    LabourRateType["PAINT_LABOUR_RATE"] = "paintLaborRate";
    LabourRateType["STRIP_REFIT_LABOUR_RATE"] = "stripRefitLaborRate";
    LabourRateType["REPAIR_LABOUR_RATE"] = "repairLaborRate";
})(LabourRateType = exports.LabourRateType || (exports.LabourRateType = {}));
